import React, {Fragment} from 'react';
import Router from './components/Router';

function App() {
    return (
        <Fragment>
            <Router />
        </Fragment>
    );
}

export default App;